import React from "react";
import styled, { css } from "styled-components";
import { Icon } from "./Icon";
import { RadioButton } from "./RadioGroup";
import { Text } from "./Text";
import { style } from "./style";

export const RadioTier = styled(RadioButton)`
  border-color: ${style.colors.grey.light};
  width: 100%;
  min-width: unset;

  ${({ selected, value, checked }) => {
    checked = checked ?? selected === value;

    return (
      checked &&
      css`
        background-color: ${style.colors.blue.lightest};
        border-color: ${style.colors.blue.dark};

        ${RadioTierLabelSubSection} {
          * {
            color: ${style.colors.blue.dark};
          }
        }

        ${RadioTierDetailsBullet} {
          fill: ${style.colors.blue.dark};
        }

        ${RadioTierDetailsWrapper} {
          border-color: ${style.colors.blue.dark};
        }
      `
    );
  }}
`;

export const RadioTierSubtitle = styled(Text).attrs({ type: "small" })`
  font-weight: ${style.vars.fontWeight.base};
  margin: ${style.vars.whitespace.regular} 0;
`;

export const RadioTierDetailsWrapper = styled.div`
  background-color: ${style.colors.white};
  border-radius: 0 0 2px 2px;
  border-top: ${style.vars.borderWidth.thin} solid ${style.colors.grey.light};
  margin: ${style.vars.whitespace.regular} -${style.vars.whitespace.regular} -${style.vars.whitespace.regular} -40px !important;
  padding: ${style.vars.whitespace.regular} 0;
`;

export const RadioTierDetailsList = styled.ul`
  color: ${style.colors.grey.darkest};
  font-size: ${style.vars.fontSize.base};
  list-style-type: none;
  margin: 0 ${style.vars.whitespace.regular} -${style.vars.whitespace.xsmall};
  padding-left: 0;
`;

export const RadioTierDetailsBullet = styled(Icon).attrs({ icon: "check" })`
  align-self: center;
  margin-right: ${style.vars.whitespace.regular};
  flex-shrink: 0;
`;

export const RadioTierDetailsItem = styled.li<{ $compact?: boolean }>`
  display: ${({ $compact }) => ($compact ? "block" : "flex")};
  margin-bottom: ${({ $compact }) => ($compact ? 0 : style.vars.whitespace.regular)};

  &:last-of-type {
    margin-bottom: ${style.vars.whitespace.xsmall};
  }
`;

export const RadioTierDetailsContent = styled.div``;

export const RadioTierLabelSubSection = styled.div``;

export const RadioTierBulletItem: React.FC = ({ children }) => (
  <RadioTierDetailsItem>
    <RadioTierDetailsBullet />
    <RadioTierDetailsContent>{children}</RadioTierDetailsContent>
  </RadioTierDetailsItem>
);
